// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"3455":"c5864aa7d4c21b7f","8462":"ab973cf0ab38ce11"}[chunkId] + ".css";
};